import RelatedProducts from "../modules/related-products";
import ProductGallery from "../modules/product-gallery";

const SingleProduct = {
  init() {
    ProductGallery.init();
    RelatedProducts.init();
  },
};

export default SingleProduct;
